import React, { useState, useEffect } from "react";
import { Badge } from "react-bootstrap";

const Posts = () => {
    const [posts, setPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                // TODO: Implement API call to fetch posts
                setIsLoading(false);
            } catch (err) {
                setError(err.message);
                setIsLoading(false);
            }
        };
        fetchPosts();
    }, []);

    if (isLoading) return (
        <div className="card">
            <div className="card-body text-center py-4">
                <i className="fa fa-spinner fa-spin" style={{ fontSize: '1.5rem', color: 'var(--themecolor)' }}></i>
                <p className="mt-2 mb-0 text-muted">Loading...</p>
            </div>
        </div>
    );

    if (error) return (
        <div className="card">
            <div className="card-body text-center py-4">
                <i className="fa fa-exclamation-circle" style={{ fontSize: '1.5rem', color: '#dc3545' }}></i>
                <p className="mt-2 mb-0 text-danger">Error: {error}</p>
            </div>
        </div>
    );

    const platformData = [
        {
            name: 'Facebook',
            logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Facebook_Logo_%282019%29.png/1200px-Facebook_Logo_%282019%29.png',
            username: 'Username',
            date: 'April 17',
            image: 'https://scontent.fbpm6-1.fna.fbcdn.net/v/t39.30808-6/475332448_122188866182188380_3614891003529038204_n.jpg?stp=dst-jpg_s960x960_tt6&_nc_cat=107&ccb=1-7&_nc_sid=127cfc&_nc_ohc=wvQCw549BSwQ7kNvwGxkegs&_nc_oc=Adn-OBpBJpaSt39cytjJP3rJbw3e11muS8fgDC-_h_s3K_fMgIzuIwTCZQRvrS3e1bo&_nc_zt=23&_nc_ht=scontent.fbpm6-1.fna&_nc_gid=3VYHJ-uB4MnHH2CFMeZAOQ&oh=00_AfG5ZcDxB7JS_ZcL8Z_CBWQXU7ArW6_mK_D1U4bxXDHFuw&oe=680D7929',
            actions: [
                { icon: 'fa-thumbs-up', label: 'Like' },
                { icon: 'fa-comment', label: 'Comment' },
                { icon: 'fa-share', label: 'Share' }
            ]
        },
        {
            name: 'Instagram',
            logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png',
            username: 'Username',
            date: 'April 17',
            image: '',
            actions: [
                { icon: 'fa-heart', label: 'Like' },
                { icon: 'fa-comment', label: 'Comment' },
                { icon: 'fa-paper-plane', label: 'Share' }
            ]
        },
        {
            name: 'Twitter / X',
            logo: 'https://pngimg.com/d/x_logo_PNG11.png',
            username: '@username',
            date: 'April 17',
            image: '',
            actions: [
                { icon: 'fa-heart', label: 'Like' },
                { icon: 'fa-comment', label: 'Comment' },
                { icon: 'fa-paper-plane', label: 'Share' }
            ]
        }
    ];

    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <h6 className="mb-0 font-weight-bold">Recently Posted</h6>
                    <Badge bg="primary" style={{ background: 'var(--themecolor)' }}>
                        {platformData.length}
                    </Badge>
                </div>

                <div className="d-flex flex-column" style={{ gap: '12px' }}>
                    {platformData.map((platform, index) => (
                        <div
                            key={index}
                            className="card"
                            style={{
                                border: '1px solid #e8e8e8',
                                borderRadius: '8px',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.08)';
                                e.currentTarget.style.borderColor = 'var(--themecolor)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.04)';
                                e.currentTarget.style.borderColor = '#e8e8e8';
                            }}
                        >
                            <div className="card-body" style={{ padding: '12px' }}>
                                {/* Platform Header */}
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                    <div className="d-flex align-items-center gap-2">
                                        <img
                                            src={platform.logo}
                                            alt={platform.name}
                                            style={{
                                                width: '20px',
                                                height: '20px',
                                                objectFit: 'contain'
                                            }}
                                        />
                                        <span style={{
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: '#333'
                                        }}>
                                            {platform.name}
                                        </span>
                                    </div>
                                    <span style={{
                                        fontSize: '11px',
                                        color: '#999'
                                    }}>
                                        {platform.date}
                                    </span>
                                </div>

                                {/* User Info */}
                                <div className="d-flex align-items-center gap-2 mb-2">
                                    <img
                                        src="//css.meddylist.com//wp-content/uploads/2025/02/doctor-visits-sick-woman-hospita-65x65.png"
                                        alt="Profile"
                                        style={{
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: '50%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={{
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            color: '#333'
                                        }}>
                                            {platform.username}
                                        </p>
                                    </div>
                                </div>

                                {/* Post Image */}
                                {platform.image && (
                                    <div className="mb-2">
                                        <img
                                            src={platform.image}
                                            alt="Post"
                                            style={{
                                                width: '100%',
                                                borderRadius: '6px',
                                                objectFit: 'cover',
                                                maxHeight: '180px'
                                            }}
                                        />
                                    </div>
                                )}

                                {/* Actions */}
                                <div className="d-flex justify-content-around pt-2" style={{
                                    borderTop: '1px solid #f0f0f0'
                                }}>
                                    {platform.actions.map((action, idx) => (
                                        <button
                                            key={idx}
                                            style={{
                                                background: 'transparent',
                                                border: 'none',
                                                color: '#666',
                                                fontSize: '11px',
                                                fontWeight: '500',
                                                cursor: 'pointer',
                                                padding: '4px 8px',
                                                transition: 'color 0.2s ease',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.color = 'var(--themecolor)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.color = '#666';
                                            }}
                                        >
                                            <i className={`fa ${action.icon}`}></i>
                                            <span>{action.label}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* View All Button */}
                <button
                    className="btn btn-sm w-100 mt-3"
                    style={{
                        background: 'var(--themecolor)',
                        border: 'none',
                        color: '#fff',
                        fontWeight: '600',
                        padding: '15px',
                        borderRadius: '6px',
                        fontSize: '10px',
                        width: '100px'
                    }}
                >
                    <i className="fa fa-eye me-2"></i>View All Posts
                </button>
            </div>
        </div>
    );
};

export default Posts;  
